<div class="blog-posts bg-light pt-4 pb-5">
    <div class="container">
        <h2 class="title" contentAnim aniName="blurIn">From Our Blog</h2>
        <owl-carousel carouselClasses="owl-simple" [options]="sliderOption" *ngIf="!loaded else loadedBlock">
            <div class="skel-pro" *ngFor="let i of [1,2,3,4,5]"></div>
        </owl-carousel>
        <ng-template #loadedBlock>
            <owl-carousel carouselClasses="owl-simple" [options]="sliderOption">
                <molla-post-four [post]="post" *ngFor="let post of posts">
                </molla-post-four>
            </owl-carousel>
        </ng-template>
    </div>
</div>